import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Menu, X, Wrench, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const dashboardPath =
    user?.role === "admin" ? "/admin"
    : user?.role === "provider" ? "/provider"
    : "/customer";

  return (
    <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-xl border-b border-slate-200">
      <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 font-display font-extrabold text-xl text-slate-900">
          <span className="inline-flex items-center justify-center w-8 h-8 rounded-xl bg-emerald-500 text-white">
            <Wrench size={18} />
          </span>
          FixNear
        </Link>

        <nav className="hidden md:flex items-center gap-6 text-sm font-semibold text-slate-700">
          <Link to="/" data-testid="nav-home" className="hover:text-emerald-600">Home</Link>
          <Link to="/request" data-testid="nav-search" className="hover:text-emerald-600">Find help</Link>
          <Link to="/emergency" data-testid="nav-emergency" className="inline-flex items-center gap-1 text-red-600 hover:text-red-700">
            <AlertTriangle size={14} /> Need help now
          </Link>
          <Link to="/signup?role=provider" data-testid="nav-become-provider" className="hover:text-emerald-600">Become a provider</Link>
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <Link to={dashboardPath} data-testid="nav-dashboard" className="text-sm font-semibold text-slate-700 hover:text-emerald-600">Dashboard</Link>
              <Button data-testid="nav-logout" onClick={() => { logout(); nav("/"); }} className="rounded-full bg-slate-900 hover:bg-slate-800 text-white">Log out</Button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="text-sm font-semibold text-slate-700 hover:text-emerald-600">Log in</Link>
              <Link to="/signup" data-testid="nav-signup"><Button className="rounded-full bg-emerald-500 hover:bg-emerald-600 text-white">Sign up</Button></Link>
            </>
          )}
        </div>

        <button data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} className="md:hidden p-2 rounded-lg hover:bg-slate-100">
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white px-4 py-4 space-y-3">
          <Link to="/" onClick={() => setOpen(false)} className="block text-slate-800 font-semibold">Home</Link>
          <Link to="/request" onClick={() => setOpen(false)} className="block text-slate-800 font-semibold">Find help</Link>
          <Link to="/emergency" onClick={() => setOpen(false)} data-testid="nav-mobile-emergency" className="inline-flex items-center gap-1 text-red-600 font-bold">
            <AlertTriangle size={14} /> Need help now
          </Link>
          <Link to="/signup?role=provider" onClick={() => setOpen(false)} className="block text-slate-800 font-semibold">Become a provider</Link>
          {user ? (
            <>
              <Link to={dashboardPath} onClick={() => setOpen(false)} className="block text-slate-800 font-semibold">Dashboard</Link>
              <button data-testid="nav-mobile-logout" onClick={() => { logout(); setOpen(false); nav("/"); }} className="btn-primary w-full">Log out</button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setOpen(false)} className="block text-slate-800 font-semibold">Log in</Link>
              <Link to="/signup" onClick={() => setOpen(false)} className="btn-accent block text-center">Sign up</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
}
